import React, {
  useState
} from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import {
  createSpecialty,
  showSpecialty,
} from '~/config/routes';
import Request from '~/providers/Request';
import SpecialtyRecord from '~/records/SpecialtyRecord';
import Form from './Form';

function NewRecord({history}){
  const [record, setRecord] = useState(new SpecialtyRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    const data = record.toParams();
    Request.post('/admin/specialties', data, {}, { controller: 'specialties' })
      .then((resp) => {
        setLoading(false);
        if(saveAndContinue){
          history.push(createSpecialty.spec);
        } else {
          history.push(showSpecialty.reverse(resp.data));
        }
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
